import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { showModal } from "actions/modal";
import messages from "utils/messages";
import { editGroup, addGroup } from "actions/groups";

export default function NewGroupModal({ group = {}, onHide }) {
  const dispatch = useDispatch();
  let submitted = false;

  const [state, setState] = useState({
    errors: [],
    ...group,
  });

  function handleNameChange(event) {
    setState({
      ...state,
      name: event.target.value,
    });
  }

  function confirmDeleteModal() {
    dispatch(
      showModal("deleteGroup", { title: messages.CONFIRM_DELETE_GROUP, group })
    );
  }

  function handleAddGroup() {
    if (submitted) return;
    submitted = true;
    if (group.id) {
      dispatch(editGroup(state));
    } else {
      dispatch(addGroup(state));
    }
    onHide();
  }

  return (
    <div className="newHabit">
      {state.errors.length ? (
        <ul className="errors">
          {state.errors.map((error) => (
            <li key={error}> {error.message} </li>
          ))}
        </ul>
      ) : null}
      <div className="field">
        <a className="label">GROUP</a>
        <input
          className="habitname"
          type="text"
          name="habitname"
          placeholder="Enter group name"
          value={state.name}
          onChange={handleNameChange}
          maxLength="40"
          autoFocus
        />
      </div>
      <div className="field">
        {group.id ? (
          <a className="delete-button" onClick={confirmDeleteModal}>
            <i className="ion-close-round" />
            <span>{messages.DELETE}</span>
          </a>
        ) : null}
        <a className="modal-button" onClick={handleAddGroup}>
          {group.id ? messages.EDIT_GROUP : messages.ADD_GROUP}
        </a>
        <a className="modal-button cancel" onClick={onHide}>
          {messages.CANCEL}
        </a>
      </div>
      <div className="clear" />
    </div>
  );
}
